



























































import { Component, Vue, Prop } from "vue-property-decorator";
import { LegalRiskState } from "../../utils/enum";
import LegalRiskTerms from "./LegalRiskTerms.vue";

@Component({
  components: {
    LegalRiskTerms
  }
})
class LegalRiskGuard extends Vue {
  @Prop() value;

  dialog = false;

  handleApprove() {
    this.$store.commit("app/SET_LEGAL_RISK_STATE", LegalRiskState.APPROVED);
  }

  handleReject() {
    this.$store.commit("app/SET_LEGAL_RISK_STATE", LegalRiskState.REJECTED);
  }

  handleCancel() {
    this.dialog = false;
  }
}
export default LegalRiskGuard;
